import { render, staticRenderFns } from "./nftorderList.vue?vue&type=template&id=960d8d02&"
import script from "./nftorderList.vue?vue&type=script&lang=js&"
export * from "./nftorderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports